import React, { Component } from 'react';
import Header from './Header.js';
import Footer from './Footer.js';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {Welcome} from './Welcome.js';
import {Code} from "./Code.js";
import {CodePlayground} from "./CodePlayground.js";

class App extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    window.klipse_settings = {
        codemirror_options_in: {
        indentUnit: 8,
        lineWrapping: true,
        lineNumbers: true,
        autoCloseBrackets: true,
        theme: "cobalt" //this.props.selectedOption
      },
        codemirror_options_out: {
        lineWrapping: true,
        lineNumbers: true,
        theme: "cobalt" //this.props.selectedOption
      },
      selector_eval_js: '.klipse', // css selector for the html elements you want to klipsify
    };

    return (

      <BrowserRouter >
        <div>
          <Route path="*" component={Header} />
          <Switch>
            <Route path="/" exact component={Welcome} />
            <Route path="/room/:id" exact component={Code}/>
            <Route path="/codePlayground" exact component={CodePlayground} />
          </Switch>
          <Footer/>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js